<template>
  <div class="caseStatistics">
    <div class="top wbg" v-if="$common.AUTH('statis:openHall:lists')">
      <a-row class="row" :gutter="40">
        <a-col class="flex" :span="6">
          <label>委托类型：</label>
          <a-select placeholder="请选择" class="select">
            <a-select-option :value="1">委托代理</a-select-option>
            <a-select-option :value="2">委托管理</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>案件类型：</label>
          <a-select class="select" v-model='form.cause_type' placeholder="请选择" allowClear>
            <!-- <a-select-option :value="0" disabled>调解</a-select-option> -->
            <a-select-option :value="2">调解</a-select-option>
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="3" disabled>公证执行</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='12' :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>管辖法院：</label>
          <a-select v-model="form.court_id" placeholder="请选择" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='14' @search="handleSearch" :default-active-first-option="false" :show-arrow="false"
            :filter-option="false" :not-found-content="null" allowClear>
            <a-select-option v-for="item in courtList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="40" style="margin-bottom:0;">
        <a-col :span="6" class="flex">
          <label>开庭日期：</label>
          <timePick @PickTime="PickTime" ref="timePicker"></timePick>
        </a-col>
        <a-col :span="8" class="flex">
          <a-button icon="search" type='primary' style="height:32px;" @click='form.page = 1; query()'>查询</a-button>
          <a-button style="height:32px;margin-left: 20px;" @click='reset'>重置</a-button>
          <a-button icon="upload" type='primary' ghost style="height:32px;margin-left:20px;" @click="out(5)"
            v-if='$common.AUTH("export:cpjladlrb")'>导出</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="tcon wbg">
      <div class="tableList" v-if="$common.AUTH('statis:openHall:lists')">
        <div class="table">
          <table>
            <thead>
              <td width="60">序号</td>
              <td width="80">债务人</td>
              <td width="160">债务人证件号码</td>
              <td width="80">所属案件</td>
              <td width="220">原告</td>
              <td width="180">案号</td>
              <td width="200">管辖法院</td>
              <td width="160">开庭时间</td>
              <td width="180">开庭地址</td>
            </thead>
            <tbody>
              <tr v-for='(i, index) in newO.list' :key='index'>
                <td>{{ index + 1 + (10 * (form.page - 1)) }}</td>
                <td>
                  <span class="curpoter" @click='dbclick(i)'>
                    <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                  </span>
                </td>
                <td>{{ i.chinaid }}</td>
                <td>
                  <p v-for='j in i.cause' :key="j.sort">
                    案件{{ j.sort }}
                  </p>
                </td>
                <td>
                  <p v-for="(j,index) in i.cause" :key="index">
                    <Normap :tit='j.accuser ? j.accuser.title : "/"'></Normap>
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause' :key="j.no">
                    <span v-if='j.no'>
                      <Normap :tit='j.no'>{{ i.no }}</Normap>
                    </span>
                    <span v-else>/</span>
                  </p>
                </td>
                <td>
                  <p v-for="(j,index) in i.cause" :key="index">
                    <Normap :tit='j.court ? j.court : "/"'></Normap>
                  </p>
                </td>
                <td>
                  <p v-for="(j,index) in i.cause" :key="index">
                    {{ j.step_dkt[0].open[0].time || '/' }}
                  </p>
                </td>
                <td>
                  <p v-for="(j,index) in i.cause" :key="index">
                    <Normap :tit='j.step_dkt[0].open[0].addr || "/"'></Normap>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pages">
          <a-pagination v-model="form.page" show-quick-jumper :total="newO.debtor_count" show-less-items :pageSize='10'
            @change='turnpage' :show-total="(total) => `债务人：${newO.debtor_count} 案件数：${newO.cause_count}`" />

        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import { getAccuserAll } from '@/server/api'
import { getDirectory } from "@/server/directory"
import { getDebtorList } from '@/server/collection'
import { exportForm } from '@/assets/js/unit'
export default {
  data() {
    return {
      newO: {
        cause_count: 0,
        debtor_count: 0,
        list: [],
      },
      courtList: [],
      accuserList: [],
      form: {
        page: 1,
        limit: 10,
        accuser_id: [],
        court_id: [],
        open_date_start: '',
        open_date_end: '',
        cause_type: undefined
      },

    }
  },
  created() {
    this.query()
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
  },
  methods: {
    out(type) {
      const form = JSON.parse(JSON.stringify(this.form));
      exportForm(type, form)
    },
    handleSearch(val) {
      getDirectory({
        limit: 100,
        title: val
      }).then((res) => {
        this.courtList = res.list
      })
    },
    turnpage(val) {
      this.form.page = val
      this.query()
    },
    ckAcc(val) {
      if (val.length > 1 || val.length == 0) {
        this.form.team_id = ''
      }
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.open_date_start = e.stime
      } else {
        this.form.open_date_end = e.etime
      }
    },
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": record.cause[0].debtor_id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    query() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString();
      form.court_id = form.court_id.toString();
      getDebtorList(form).then(e => {
        this.newO = e;
      })
    },
    reset(){
      this.form.limit = 10
      this.form.page = 1
      this.form.cause_type = undefined
      this.form.accuser_id = []
      this.form.court_id = []
      this.form.open_date_start = ''
      this.form.open_date_end = ''
      this.$refs.timePicker.clearTime()
      this.query()
    }
  }
}
</script>
<style lang="less" scoped>
.caseStatistics {
  padding-bottom: 50px;
  @import url('@/assets/css/search.less');
}

.tcon {
  padding: 0 20px;
  min-height: 720px;

  .tableList {
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 10px 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}

.pages {
  text-align: right;
  position: relative;
}
</style>
